import {
	ACCEPT_TERMS_SUCCESS,
	ALLOW_MARKETING_SUCCESS,
	CHECK_PHONE_CODE_SUCCESS,
	CUSTOMER_SUCCESS,
	DISCOUNT_FAILURE,
	REGISTER_STRIPE_CARD_SUCCESS,
	SEND_ORDER_FAILURE,
	SET_BIRTHDATE_SUCCESS,
	SET_EMAIL_SUCCESS,
	SET_NAME_SUCCESS,
	SET_PHONE_SUCCESS,
} from 'new-constants/api.constants';
import {
	GLOBAL_MENU_CHANGE,
	GLOBAL_RESTAURANT_VERSION,
	PRIVATE_CUSTOMER_GROUP,
} from 'new-constants/pusher.constants';
import {DONE_LOGOUT_CONFIRMATION} from 'new-constants/popup.constants';
import {SET_EMAIL_MARKETING_CONSENT, SET_SMS_MARKETING_CONSENT} from 'new-constants/customer.constants';
import {PROFILE_STRIPE_SUCCES} from 'new-constants/payment.constants';
import {CustomerState} from './customer.reducer.types';
import {GLOBAL_WORKING_TIME} from '../constants/pusher.constants';
import {
	CHECK_ADYEN_PAYMENT_SUCCESS,
	CHECK_PAYMENT_STATUS_SUCCESS, ORDER_SUCCESS, SEND_ORDER_SUCCESS,
	SET_GUEST_SUCCESS,
	SUBMIT_APPLE_PAY_SUCCESS,
	SUBMIT_GOOGLE_PAY_SUCCESS
} from "../constants/api.constants";
import {START} from "../constants/app-state.constants";
import {ADYEN_SUCCESS, STRIPE_SUCCESS, VIPPS_SUCCESS} from "../constants/payment.constants";
import {PaymentStatuses} from "../constants/common.constants";
import {defaultPurchaseCacheEntry} from "./purchase.reducer";

const initialState: CustomerState = {
	udid: null,
	currentCustomer: null,
	isFetchedOnce: false,
	isSetUAChannelIdInProgress: false,
	currentGuest: null,
};

export const customerReducer = (previousState = initialState, action): CustomerState => {
	switch (action && action.type) {
		case CUSTOMER_SUCCESS:
			//if (action.isAppIdMatching) {
			return {
				...previousState,
				currentCustomer: {
					...action.payload.data,
				},
				udid: action.payload.udid,
				isFetchedOnce: true,
			};
			//}

			return {
				...previousState,
			};
			break;

		case SET_PHONE_SUCCESS:
			return {
				...previousState,
				currentCustomer: {
					...previousState.currentCustomer,
					verificationCodePhone: action.payload.phone,
					terms: action.payload.terms || previousState.currentCustomer.terms,
				},
			};
			break;

		case SET_NAME_SUCCESS:
			return {
				...previousState,
				currentCustomer: {
					...previousState.currentCustomer,
					nickname: action.payload.data.nickname,
				},
			};
			break;

		case SET_EMAIL_SUCCESS:
			return {
				...previousState,
				currentCustomer: {
					...previousState.currentCustomer,
					email: action.payload.email,
				},
			};
			break;

		case SET_BIRTHDATE_SUCCESS:
			return {
				...previousState,
				currentCustomer: {
					...previousState.currentCustomer,
					birthdate: action.payload.birthdate.split('.').reverse().join('.'),
				},
			};
			break;

		case CHECK_PHONE_CODE_SUCCESS:
			return {
				...previousState,
				udid: action.payload.data.cid,
				currentCustomer: {
					...previousState.currentCustomer,
					birthdate: action.payload.data.birthdate,
					cardNumber: action.payload.data.cardNumber,
					email: action.payload.data.email,
					hasCard: action.payload.data.hasCard,
					hasPassword: action.payload.data.hasPassword,
					marketing: action.payload.data.marketing,
					nickname: action.payload.data.nickname,
					phone: action.payload.data.phone,
					terms: action.payload.data.terms,
				},
			};
			break;

		case GLOBAL_RESTAURANT_VERSION:
			if (
				!!previousState.currentCustomer &&
				previousState.currentCustomer.restaurant &&
				previousState.currentCustomer.restaurant.restaurantId.toString() === action.data.restaurantId.toString()
			) {
				return {
					...previousState,
					currentCustomer: {
						...previousState.currentCustomer,
						restaurant: {
							...previousState.currentCustomer.restaurant,
							version: action.data.version,
						},
					},
				};
			}

			return previousState;
			break;

		case GLOBAL_MENU_CHANGE:
			if (
				action.data?.restaurantId &&
				previousState.currentCustomer?.restaurant?.restaurantId === action.data.restaurantId &&
				action.data.menuVersion
			) {
				return {
					...previousState,
					currentCustomer: {
						...previousState.currentCustomer,
						restaurant: {
							...previousState.currentCustomer.restaurant,
							menuVersion: action.data.menuVersion,
						},
					},
				};
			}

			return previousState;
			break;

		case PRIVATE_CUSTOMER_GROUP:
			if (previousState.currentCustomer && action.data.customerGroupIds) {
				return {
					...previousState,
					currentCustomer: {
						...previousState.currentCustomer,
						customerGroupIds: action.data.customerGroupIds,
					},
				};
			}

			return previousState;
			break;

		case DONE_LOGOUT_CONFIRMATION:
			return {
				...previousState,
				appId: null,
				udid: null,
				currentCustomer: null,
			};
			break;

		case SET_EMAIL_MARKETING_CONSENT:
			if (previousState.currentCustomer && previousState.currentCustomer.marketing) {
				return {
					...previousState,
					currentCustomer: {
						...previousState.currentCustomer,
						marketing: {
							...previousState.currentCustomer.marketing,
							allowEmail: action.newEmailMarketingConsent,
						},
					},
				};
			}

			return previousState;
			break;

		case SET_SMS_MARKETING_CONSENT:
			if (previousState.currentCustomer && previousState.currentCustomer.marketing) {
				return {
					...previousState,
					currentCustomer: {
						...previousState.currentCustomer,
						marketing: {
							...previousState.currentCustomer.marketing,
							allowSms: action.newSmsMarketingConsent,
						},
					},
				};
			}

			return previousState;
			break;

		case ALLOW_MARKETING_SUCCESS:
			if (previousState.currentCustomer && previousState.currentCustomer.marketing) {
				return {
					...previousState,
					currentCustomer: {
						...previousState.currentCustomer,
						marketing: action.payload.data.marketing,
					},
				};
			}

			return previousState;
			break;

		case SEND_ORDER_FAILURE:
		case DISCOUNT_FAILURE:
			if (
				action.meta?.restaurantId === previousState.currentCustomer?.restaurant?.restaurantId &&
				action.meta?.data?.syncMenu
			) {
				return {
					...previousState,
					currentCustomer: {
						...previousState.currentCustomer,
						restaurant: {
							...previousState.currentCustomer.restaurant,
							menuVersion:
								action.meta.data.syncMenu.menuVersion || previousState.currentCustomer.restaurant.menuVersion,
						},
						customerGroupIds:
							action.meta.data.syncMenu.customerGroupIds || previousState.currentCustomer.customerGroupIds,
					},
				};
			}

			return previousState;
			break;

		case REGISTER_STRIPE_CARD_SUCCESS:
			return {
				...previousState,
				currentCustomer: {
					...previousState.currentCustomer,
					cardNumber: null,
				},
			};
			break;

		case PROFILE_STRIPE_SUCCES:
			return {
				...previousState,
				currentCustomer: {
					...previousState.currentCustomer,
					cardNumber: '**** **** **** ****',
				},
			};
			break;

		case ACCEPT_TERMS_SUCCESS:
			return {
				...previousState,
				currentCustomer: {
					...previousState.currentCustomer,
					terms: action.payload.data.terms,
					marketing: action.payload.data.marketing,
				},
			};
			break;

		case GLOBAL_WORKING_TIME:
			if (action.data?.restaurantId === previousState.currentCustomer?.restaurant?.restaurantId) {
				return {
					...previousState,
					currentCustomer: {
						...previousState.currentCustomer,
						restaurant: {
							...previousState.currentCustomer.restaurant,
							autoMode: action.data.autoMode,
							firstDeliveryTime: action.data.firstDeliveryTime,
							firstPickupTime: action.data.firstPickupTime,
							isOpen: action.data.isOpen,
							isTemporaryStopOrders: action.data.isTemporaryStopOrders,
							isTooBusyForNewOrders: action.data.isTooBusyForNewOrders,
							lastDeliveryTime: action.data.lastDeliveryTime,
							lastPickupTime: action.data.lastPickupTime,
							preOrder: action.data.preOrder,
							startStopTime: action.data.startStopTime,
                            isSlowService: action.data.isSlowService,
						}
					}
				};
			}

		case SET_GUEST_SUCCESS:
			return {
				...previousState,
				currentGuest: {
					name: action.payload.name,
					phone: action.payload.phone,
				},
			};
			break;

		case START:
			return {
				...previousState,
				currentGuest: null,
			};
			break;

			return previousState;
			break;

		case SEND_ORDER_SUCCESS:
			if (action.payload.isOrderSent) {
				return {
					...previousState,
					currentGuest: null,
				};
			}

			return previousState;
			break;

		case STRIPE_SUCCESS:
		case VIPPS_SUCCESS:
			return {
				...previousState,
				currentGuest: null,
			};
			break;

		case ADYEN_SUCCESS:
			if (action.payload.action.type === 'redirect' || action.payload.action.type === 'threeDS2' || action.payload.action.type === 'swish') {
				return {
					...previousState,
				}
			}
			return {
				...previousState,
				currentGuest: null,
			};
			break;

		case SUBMIT_GOOGLE_PAY_SUCCESS:
		case SUBMIT_APPLE_PAY_SUCCESS:
			return {
				...previousState,
				currentGuest: null
			};
			break;

		case CHECK_PAYMENT_STATUS_SUCCESS:
			if (!(action.payload.isAdyenOrder && action.payload.data.status === PaymentStatuses.complete)) {
				return previousState;
			}

			return {
				...previousState,
				currentGuest: null,
			};
			break;

		case CHECK_ADYEN_PAYMENT_SUCCESS:
			if (action.payload.data.resultCode !== PaymentStatuses.authorised) {
				return previousState;
			}

			return {
				...previousState,
				currentGuest: null,
			};
			break;

		case ORDER_SUCCESS:
			if (!(action.payload.isScheduledForCancel && action.payload.data.order.isPaid)) {
				return previousState;
			}

			return {
				...previousState,
				currentGuest: null,
			};
			break;


		default:
			return previousState;
	}
};
